import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import type { InferType } from "yup";
import type { AvailableSlot } from "../../models";
import { CalendarTimeSelect } from "./calendar-time-select";
import { useValidationSchema } from "./validation-schema";

export type TimeSelectFormValues = InferType<ReturnType<typeof useValidationSchema>>;

type TimeSelectFormProps = {
  availableSlots?: AvailableSlot[];
  defaultTimeSlot?: Date;
  onTimeChange: (time: TimeSelectFormValues["time"]) => void;
};

export const TimeSelectForm = ({ availableSlots = [], defaultTimeSlot, onTimeChange }: TimeSelectFormProps) => {
  const { control, watch } = useForm<TimeSelectFormValues>({
    mode: "onChange",
    resolver: yupResolver(useValidationSchema()),
  });

  const time = watch("time");

  useEffect(() => {
    onTimeChange(time);
  }, [time, onTimeChange]);

  if (availableSlots.length === 0) return null;

  return (
    <form>
      <Controller
        name="time"
        control={control}
        defaultValue={defaultTimeSlot}
        render={({ onChange, value }) => (
          <CalendarTimeSelect availableSlots={availableSlots} value={value} onChange={onChange} />
        )}
      />
    </form>
  );
};
